import { computed } from 'vue';

export default function usePlatform() {
  const isWindows = computed((): boolean => navigator?.userAgent.indexOf('Windows') !== -1);
  const isMac = computed((): boolean => navigator?.userAgent.indexOf('Mac') !== -1);

  return {
    isWindows,
    isMac,
  };
}
